import PlaceDetails from './place-details';

export default PlaceDetails;
